<template>
    <div class="page-header header-filter" filter-color="orange">
        <div class="page-header-image"
             style="background-image: url('img/homepage/predictionHero.jpg')">
        </div>
        <div class="content">
            <div class="container">
                <div class="col-md-5 ml-auto mr-auto">
                    <h4>Login or Register <br> to access predictions</h4>
                    <card type="login" plain>
                        <fg-input class="no-border input-lg"
                                  v-model="email"
                                  addon-left-icon="now-ui-icons users_circle-08"
                                  placeholder="Email...">
                        </fg-input>

                        <fg-input class="no-border input-lg"
                                  type="password"
                                  v-model="password"
                                  addon-left-icon="now-ui-icons text_caps-small"
                                  placeholder="Password...">
                        </fg-input>

                        <template slot="raw-content">
                            <div class="card-footer text-center">
                                <a @click="login()" class="btn btn-primary btn-round btn-lg btn-block">Login</a>
                            </div>
                            <!-- <div class="card-footer text-center">
                                <a href="/#/membersRegisteration" class="btn btn-neutral btn-round btn-lg btn-block">Create Account</a>
                            </div> -->
                            <br>
                            <div class="pull-center">
                                <h6>
                                    <a href="/#/membersRegisteration" class="link footer-link">Create Account</a>
                                </h6>
                            </div>
                            <!-- <div class="pull-right">
                                <h6>
                                    <a href="#pablo" class="link footer-link">Need Help?</a>
                                </h6>
                            </div> -->
                        </template>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import { Card, Button, FormGroupInput } from '@/components';
  import MainFooter from '@/layout/MainFooter';
  import db from '../../components/Firebase/firebaseInit'
  import firebase from 'firebase';
  export default {
    name: 'login-page',
    bodyClass: 'login-page',
    components: {
      Card,
      MainFooter,
      [Button.name]: Button,
      [FormGroupInput.name]: FormGroupInput
    },
        data() {
        return {
        email: '',
        password: ''
        };
    },
    methods: {
    login () {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(
          user => {
            // console.log(user);
            // alert(`You are logged in as ${this.email}`);
            this.$router.push('/predictionList');
          },
          err => {
            alert(err.message);
          }
        );
      e.preventDefault();
    }
  }
  }
</script>
<style>
</style>
